import PropTypes from "prop-types";
import { Box, Link } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Link as RouterLink } from "react-router-dom";

/**
 * Renders a display name as a link to the user profile, or plain text when userId is missing.
 *
 * @param {Object} props
 * @param {string} [props.userId] - Target user id for `/user?userId=…`
 * @param {React.ReactNode} props.children - Link label (typically the user's name)
 * @param {boolean} [props.showIcon=true] - Whether to show the person icon before the link
 */
function UserLink({ userId, children, showIcon = true }) {
  const label = children ?? "—";

  if (!userId) {
    return label;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {showIcon && <PersonOutlineIcon fontSize="small" sx={{ color: "action.active", flexShrink: 0 }} />}
      <Link component={RouterLink} to={`/user?userId=${userId}`} underline="hover">
        {label}
      </Link>
    </Box>
  );
}

UserLink.propTypes = {
  userId: PropTypes.string,
  children: PropTypes.node,
  showIcon: PropTypes.bool,
};

export default UserLink;
